export default __webpack_public_path__ + "locales/az/ChangeUserTypeDialog.json?hash=732f6952a9a63e3f8303210cc27fb6aa";